import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {roomShareNoteService} from "@/core/service/room.shareNote.service";
import { RoomInfo } from '@/core/api/room.info.api'

class RoomShareNoteApi extends BaseApi {

    constructor() {
        super();
        Room.ShareNote = this;

        Room.ready(async e => {
            if(!RoomInfo.useModule('shareNote')){
                return;
            }

            this._eventListen(this.#Events);

            let {data} = await roomShareNoteService.getRoomShareNoteInfoList();

            let roomGroups = data.reduce((map, roomShareNote) => {
                map[roomShareNote.roomGroupId] = roomShareNote;
                Room.Group.addData(roomShareNote.roomGroupId, {roomShareNote});
                return map;
            }, {});

            let roomShareNote = roomGroups['default'];
            // roomShareNote.roomGroups = roomGroups;

            // roomShareNote.logs = [];

            Room.addRoomData({roomShareNote});
        });
    }

    #Events = {
        room_sharenote_historyAdded: async function(e){
            e.data.history = JSON.parse(e.data.history);
            Room.emit(e);
        },
        room_sharenote_operation: async function(e){
            if(e.data.operation.data){
                e.data.operation.data = JSON.parse(e.data.operation.data);
            }
            Room.emit(e);
        },
        room_sharenote_remove: function(e) {
            Room.emit(e)
        },
        room_sharenote_noteLogAdded: function(e) {
            let roomShareNote = this.getRoomShareNote();

            if (!roomShareNote.logs) {
                roomShareNote.logs = [];
            }
            roomShareNote.logs.unshift(e.data.shareNoteLog);
            Room.emit(e)
        },
        room_sharenote_changeNote: function(e) {
            let roomShareNote = this.getRoomShareNote();
            roomShareNote.noteId = e.data.noteId;
            Room.emit(e);
        }
    };

    getRoomShareNote(/*{roomGroupId}*/) {
        return Room.getRoomData().roomShareNote;
    }

    async getRoomShareNoteLogList() {
        let roomData = Room.getRoomData();
        if(!roomData.roomShareNote.logs){
            let {data} = await roomShareNoteService.getRoomShareNoteLogList();
            roomData.roomShareNote.logs = data || [];
        }
        return roomData.roomShareNote.logs;
    }

    async getRoomShareNoteLogData({noteId}) {
        if(!noteId){
            console.warn('noteId is null');
            return Promise.resolve(null);
        }

        let {data} = await roomShareNoteService.getRoomShareNoteLogData({noteId})
        data.historyData = data.historyData || [];
        if(data.historyData && typeof(data.historyData) === 'string'){
            data.historyData = JSON.parse(data.historyData);
            if(Array.isArray(data.historyData)){
                data.historyData.forEach(history => {
                    if(!history.data) return;
                    if(typeof(history.data) === 'string'){
                        history.data = JSON.parse(history.data);
                    }
                });
            }
        }
        if(data.data && typeof(data.data) === 'string'){
            data.data = JSON.parse(data.data);
        }
        return data;
    }

    async changeRoomShareNote({roomGroupId, noteId}) {
        return roomShareNoteService.changeNote({roomGroupId, noteId});
    }

    async getCheckpoint({roomGroupId}) {
        let {data} = await roomShareNoteService.getCheckpoint({roomGroupId});
        return JSON.parse(data);
    }

    async saveCheckpoint({roomGroupId, data}) {
        return await roomShareNoteService.saveCheckpoint({
            roomGroupId,
            data: {
                id: data.id,
                data: JSON.stringify(data)
            }
        });
    }
    async removeCheckpoint({roomGroupId}) {
        await roomShareNoteService.removeCheckpoint({
            roomGroupId
        });
    }

    async getHistoryList({roomGroupId, revisionId}) {
        let {data} = await roomShareNoteService.getHistory({roomGroupId, revisionId});
        if(!data){
            return [];
        }
        data.forEach(history => {
            history.data = JSON.parse(history.data);
        });
        return data;
    }

    async addHistory({roomGroupId, data}) {
        await roomShareNoteService.addHistory({
            roomGroupId,
            data: {
                id: data.id,
                data: JSON.stringify(data)
            }
        });
        // Room.getClient().send(`/room/shareNote/${roomGroupId}/history/add`, {
        //     id: data.id,
        //     data: JSON.stringify(data),
        //     unreliable: true
        // });
    }
    async removeHistory({roomGroupId}) {
        await roomShareNoteService.removeHistory({
            roomGroupId
        });
    }

    async sendOperation({roomGroupId, operation}) {
        if(operation.type.startsWith('cursor')){
            if(Room.User.getRoomUserList().length <= 1){
                return;
            }
        }

        await roomShareNoteService.sendOperation({
            roomGroupId,
            operation: {
                type: operation.type,
                data: JSON.stringify(operation.data)
            }
        });
        // Room.getClient().send(`/room/shareNote/${roomGroupId}/sendOperation`, {
        //     type: operation.type,
        //     data: JSON.stringify(operation.data),
        //     unreliable: true
        // });
    }


}

export const RoomShareNote = new RoomShareNoteApi();